import PrivateStack from './PrivateStack';

export default PrivateStack;
